/*
 * Visualiseur InstrumenPoche en Javascript et SVG
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const IepDoc = require('./IepDoc')
module.exports = IepApp

/**
 * Fonction créant un objet permettant de gérer plusieurs figures instrumenPoche
 * dans des svg différents
 * @param {Object} [options]
 * @param {boolean} [options.debug] passer true pour avoir des infos de debug en console
 * @constructor
 */
function IepApp (options) {
  this.debug = Boolean(options && options.debug)
  if (this.debug) console.log('Mode debug activé')
  this.docs = []
  const self = this
  window.addEventListener('unload', () => self.closeAllXMLWindows())
}

/**
 * Fonction ajoutant un document à un iepApp
 * @param {string|Element} svg : Le svg (l'élément du dom ou son id) dans lequel vont se faire les affichages.
 * @param {string} chDoc : La chaîne XML décrivant le document.
 * @param {boolean} [autoStart=true] Passer false pour ne pas démarrer l'animation dès le chargement
 */
IepApp.prototype.addDoc = function (svg, chDoc, autoStart = true) {
  if (typeof svg === 'string') svg = document.getElementById(svg)
  if (!svg) return new Error('svg manquant')
  if (svg.localName !== 'svg') return new Error('svg incorrect')
  const options = {
    autoStart,
    debug: this.debug
  }
  const doc = new IepDoc(svg, chDoc, options)
  this.docs.push(doc)
  svg.iepDoc = doc // Pour que les boutons accèdent au document.
  return doc
}

/**
 * Fonction utilisée lors de la fermeture d'une fenêtre contenant des figures
 * InstrumenPoche dans des SVG.
 * Elle provoque la fermeture des éventuelles fenêtres popup contenant le code
 * XML d'une figure (obtenues en cliquant sur une icône XML)
 */
IepApp.prototype.closeAllXMLWindows = function () {
  for (let i = 0; i < this.docs.length; i++) {
    const doc = this.docs[i]
    if (doc.windowxml != null) doc.windowxml.close()
  }
}
